module.exports = __webpack_public_path__ + "img/testimonyQuote.ac7077e3.png";